/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, forwardRef } from "react";
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogProps, DialogSurface, DialogTitle, DialogTrigger, Text } from "@fluentui/react-components";
import { ShieldQuestionRegular } from "@fluentui/react-icons";
import { Column, Row } from "../common";
import { useDialogControls } from "./useDialogControls";

export type ConfirmationDialogProps = Omit<Partial<DialogProps>, 'onOpenChange'> & {
    children?: React.ReactElement;
    title?: string;
    icon?: JSX.Element;
    text?: string | JSX.Element;
    onConfirm?: (e?: React.MouseEvent) => void;
    onCancel?: (e?: React.MouseEvent) => void;
    confirmButtonText?: string;
    cancelButtonText?: string;
    open?: boolean;
    onOpenChange?: (isOpen: boolean) => void;
    onClickTrigger?: (e: React.MouseEvent<any> | React.KeyboardEvent<any>) => void;
    action?: JSX.Element;
}
export const ConfirmationDialog = forwardRef((props: ConfirmationDialogProps, _ref) => {

    const { children, action, title = 'Confirmation', text, icon, confirmButtonText = 'Yes', cancelButtonText = 'No', modalType, onConfirm, onCancel, open, onOpenChange } = props;

    const [dialogOpen, onOpenChangeHandler] = useDialogControls(open, onOpenChange);

    //UI Events
    const clickConfirm = (e: React.MouseEvent) => {
        e.stopPropagation();
        
        !!onConfirm && onConfirm(e);
    }
    const clickCancel = (e: React.MouseEvent) => {
        e.stopPropagation();

        !!onCancel && onCancel(e);
    }

    return (
        <>
            <Dialog modalType={modalType} open={dialogOpen} onOpenChange={onOpenChangeHandler}>
                <DialogTrigger disableButtonEnhancement>
                    {children}
                </DialogTrigger>
                <DialogSurface>
                    <DialogBody>
                        <DialogTitle>
                            <Row gap='medium'>
                                <Column width='auto' vAlign='middle'>
                                    {icon || <ShieldQuestionRegular />}
                                </Column>
                                <Column>
                                    {title}
                                </Column>
                            </Row>
                        </DialogTitle>
                        <DialogContent>
                            <Column height='auto'>
                                <Text size={400}>{text}</Text>
                            </Column>
                            {!!action && (
                                <Column height='auto' padding='pt-3'>
                                    {action}
                                </Column>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <DialogTrigger disableButtonEnhancement>
                                <Button type="submit" appearance="primary" onClick={clickConfirm} data-testid='confirmation-dialog-confirm-button'>
                                    {confirmButtonText}
                                </Button>
                            </DialogTrigger>
                            <DialogTrigger disableButtonEnhancement>
                                <Button appearance="secondary" onClick={clickCancel} data-testid='confirmation-dialog-cancel-button'>
                                    {cancelButtonText}
                                </Button>
                            </DialogTrigger>
                        </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
        </>
    );
});